import React from 'react';
import { 
	func,
	object,
	bool
} from 'prop-types';
import {sortQuizzes,insertNumer,shuffleQuizzes,checkForValidQuiz} from '../../../logics/quiz';
import {makeRecipeResults,makeScore} from '../../../logics/answerChecker';


export default class Container extends React.Component {
	static propTypes = {
		isSample : bool.isRequired,
		recipe : object,
		answers : object,
		onSubmit : func,
		onDiscard : func,
		render:func
	}
    
	constructor(props){
		super(props);
		const {answers,  recipe = {}, isSample} = props;
		const { quizzes : quizzesBase = [],shuffle=false} = recipe;
		const quizBaseWithoutSample = quizzesBase.filter(q=>checkForValidQuiz(q,isSample));
		const quizzes = shuffle ? insertNumer(shuffleQuizzes(quizBaseWithoutSample)) : insertNumer(sortQuizzes(quizBaseWithoutSample));
		this.state = {
			answers : Object.assign({},answers),
			quizzes,
			quizIndex : 0,
			showResult : false,
			openAnswer : false 
		};
	}

	componentDidMount = ()=>{
    	window.scrollTo(0, 0);
	}
    
	render(){
        
		const { recipe = {}, onSubmit, onDiscard, render} = this.props;
		const { timeLimit = 0, id:recipeId=null} = recipe;
		const quizzes = this.state.quizzes;
		const quiz = quizzes.length > this.state.quizIndex ? quizzes[this.state.quizIndex] : null;
		const quizSize = quizzes.length;
		if(!quiz) return render({
			quizContentProps : null,
		});
		
		const quizContentProps={
			quiz:quiz,
			quizSize,
			timeLimit : timeLimit * 1000,
			answers:this.state.answers[quiz.id] || {},
			isLastQuestion:quizzes.length-1 === this.state.quizIndex,
			openAnswer : this.state.openAnswer,
			onAnswer:(correctAnswer,idx,answer)=>{
				let answers = Object.assign({},this.state.answers);
				if(! (quiz.id in answers)){
					answers[quiz.id] = {};
				}
				answers[quiz.id][correctAnswer] = answer;
				this.setState({answers:answers});
			},
			onNext:()=>{
				if(quizzes.length > this.state.quizIndex){
					this.setState({quizIndex:this.state.quizIndex+1});
					window.scrollTo(0, 0);
				}
			},
			onBack:()=>{
				if(this.state.quizIndex > 0){
					this.setState({quizIndex:this.state.quizIndex-1});
					window.scrollTo(0, 0);
				}
			},
			onSubmit:()=>{
				this.setState({showResult:true});
			},
			onOpenAnswer : (open)=>{
				this.setState({openAnswer:open});
			},
			onTimeout:()=>{
				this.setState({showResult:true});
			}
		};
        
		let quizResultProps = null;
		if(this.state.showResult){
			const results = makeRecipeResults(this.state.answers, quizzes);
			const score = makeScore(results);
			quizResultProps={
				score:score,
				onSave:()=>{onSubmit({
					recipeId,
					date : Date.now(),
					...score});
				},
				onClose:onDiscard
			};
		}

		
		return render({
			quizContentProps,
			quizResultProps,
			showResult : this.state.showResult
		});
	}
}